<template>
  <div class="video-box" :style="`padding: ${padding};`">
    <div class="video-in">
      <div class="video-kv" v-show="liveState !== 2">
        <img :src="poster" alt="" />
        <!-- <img
          src="https://imgsauoscom.oss-cn-shanghai.aliyuncs.com/yilininfo/yilininfo_6fdd3d7e1ed844cd8facdafa65a42635.png"
          alt=""
        /> -->
      </div>
      <video
        id="my-video"
        class="video-js vjs-default-skin vjs-big-play-centered"
        controls
        disablePictureInPicture
        :poster="poster"
        :width="width"
        preload="auto"
      ></video>
    </div>
  </div>
</template>

<script>
import videojs from 'video.js'
import 'videojs-contrib-hls'
import { mapGetters } from 'vuex'
export default {
  data() {
    return {
      player: null,
      isTrue: true,
      timer: null,
      KV: '',
      // liveAddress: [{
      //   src: 'https://p6.vzan.com/290332/736826529958885216/live.m3u8?zbid=290332&tpid=2006557082'
      // }, {
      //   src: 'http://dongli-yun.oss-cn-shanghai.aliyuncs.com/data/indeximg/IAEA/55/66/88/89/45/2022/8/09/9cae6e63/m3u8.m3u8'
      // }, {
      //   src: 'http://dongli-yun.oss-cn-shanghai.aliyuncs.com/data/indeximg/IAEA/55/66/88/89/45/2022/08/09/9cae6e63/m3u8.m3u8'
      // }]
      liveAddress: []
    }
  },
  computed: {
    ...mapGetters(['liveState'])
  },
  props: {
    width: {
      type: String,
      default: '100%'
    },
    isPlay: {
      type: Boolean,
      default: false
    },
    liveInfo: {
      type: Object,
      default: () => {
        return {
          live: {},
          liveStream: {}
        }
      }
    },
    poster: {
      type: String,
      default: ''
    },
    padding: {
      type: String,
      default: ''
    }
  },
  watch: {
    poster(n) {
      console.log(n)
      if (!this.isTrue) {
        document.getElementsByClassName(
          'vjs-poster'
        )[0].style = `background: url(${n});`
      }
    },
    liveInfo() {
      if (this.isTrue) {
        // console.log(this.isTrue)
        this.$nextTick(() => {
          this.getVideo()
        })
        this.isTrue = false
      } else {
        this.KV = false
        this.$emit('childData', this.KV)
        // console.log(this.timer)
        clearInterval(this.timer)
        this.$store.commit('state/SET_LIVESTATE', 1)
        this.isState()
        const time = new Date().getTime()
        if (time >= this.liveInfo.live.livetime * 1000) {
          this.timer = setInterval(() => {
            this.isState()
          }, 1000)
        }
      }
    }
  },
  mounted() {
    // this.$nextTick(() => {
    //   this.getVideo();
    // });
  },
  methods: {
    getVideo() {
      this.player = videojs(
        'my-video',
        {
          bigPlayButton: true, // 显示播放按钮
          textTrackDisplay: false,
          posterImage: true,
          errorDisplay: false,
          controlBar: true // 显示控件
        },
        (that) => {
          this.player.on('play', () => {
            this.$emit('update:isPlay', true)
          })
          this.player.on('error', () => {
            this.liveAddress.shift()
            if (!this.liveAddress.length) {
              console.log('即将开始')
              this.$store.commit('state/SET_LIVESTATE', 2)
            } else {
              this.player.src(this.liveAddress[0])
              // this.$store.commit('state/SET_LIVESTATE', 2)
            }
          })
          const time = new Date().getTime()
          this.isState()
          if (time >= this.liveInfo.live.livetime * 1000) {
            this.timer = setInterval(() => {
              this.isState()
            }, 5000)
          }
        }
      )
    },
    isState() {
      if (this.liveState === 1) {
        this.liveAddress = []
        const data = this.liveInfo.liveStream
        for (let key in data) {
          if (key.indexOf('Address') !== -1) {
            if (data[key]) {
              this.liveAddress.push({ src: data[key] })
            }
          }
        }
        if (!this.liveAddress.length) {
          console.log('即将开始')
          this.$store.commit('state/SET_LIVESTATE', 1)
          return
        }
        this.player.src(this.liveAddress[0])
        if (this.liveAddress.length) {
          this.$store.commit('state/SET_LIVESTATE', 2)
        }
      } else {
        clearInterval(this.timer)
      }
    },
    play(arr) {
      this.player.play(arr)
    },
    pause() {
      this.player.pause()
    }
  },
  beforeDestroy() {
    if (this.player) {
      this.player.dispose()
      this.player = null
      clearInterval(this.timer)
    }
  }
}
</script>

<style lang="scss" scoped>
.video-box {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  box-sizing: border-box;
  .video-in {
    display: flex;
    width: 100%;
    height: 100%;
    position: relative;
  }
  #my-video {
    margin: auto;
    width: 100%;
    height: 100%;
  }
  ::v-deep .video-js .vjs-big-play-button {
    font-size: 6em !important;
    color: rgba(255, 255, 255, 0.5) !important;
    background: none;
    border: none;
  }
}
.video-kv {
  width: 100%;
  height: 100%;
  z-index: 999;
  position: absolute;
  top: 0;
  left: 0;
  img {
    width: 100%;
    height: 100%;
  }
}
::v-deep .vjs-poster {
  background-size: 100% 100% !important;
}
</style>
